import { render, staticRenderFns } from "./score-input.vue?vue&type=template&id=2717af40&scoped=true&"
import script from "./score-input.vue?vue&type=script&lang=js&"
export * from "./score-input.vue?vue&type=script&lang=js&"
import style0 from "./score-input.vue?vue&type=style&index=0&id=2717af40&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2717af40",
  null
  
)

export default component.exports